export const WORKSPACE_LOCK_NAME = "workspace-rgl-shared-v3";

export class WorkspaceRepositoryUnavailableError extends Error {
  constructor() {
    super("The shared workspace repository requires the Web Locks API");
    this.name = "WorkspaceRepositoryUnavailableError";
  }
}

export interface WorkspaceLock {
  run: <T>(callback: () => T | Promise<T>) => Promise<T>;
}

interface CreateWorkspaceLockOptions {
  navigatorLocks?: LockManager | null;
  name?: string;
}

// Chrome is the product target. Cross-window repository writes require the
// standards-based Web Locks API and deliberately have no unsafe fallback.
export const createWorkspaceLock = ({
  navigatorLocks = navigator.locks,
  name = WORKSPACE_LOCK_NAME,
}: CreateWorkspaceLockOptions = {}): WorkspaceLock => {
  if (!navigatorLocks) {
    throw new WorkspaceRepositoryUnavailableError();
  }
  return {
    run: async <T>(callback: () => T | Promise<T>): Promise<T> =>
      await navigatorLocks.request(name, callback),
  };
};
